import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PropTypes from 'prop-types';

import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';

function PartnerLink({ partner }) {
  return (
    <Link
      href={partner.url}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      color="text.secondary"
      sx={{
        pt: 1,
        pl: 1,
        '&:hover': { color: 'text.secondary' }
      }}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {partner.name}
        <OpenInNewIcon fontSize="small" />
      </Stack>
    </Link>
  );
}

PartnerLink.propTypes = {
  partner: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired
};

export default PartnerLink;
